type Props = {
  rawValue?: string
  choices: (string | {
    value: string | number
    text: string
  })[]
  displayValue: any
}

export function SurveyQuestionAnswerSingleChoice({ rawValue, choices, displayValue }: Props) {
  if (typeof rawValue !== 'string') {
    return <span className="text-gray-400">未選択</span>
  }

  /**
   * 回答が other、または設問の選択肢にない回答の場合は「その他」とする
   * 「その他」のみ:
   * {
   *   "01J9X5MTBE1DV2HBRJYWA2X63H": "other",
   *   "01J9X5MTBE1DV2HBRJYWA2X63H-Comment": "fffff"
   * }
   * 「その他」と「コメント領域を表示する」:
   * {
   *   "01J9X5NFS9VKEKGFME97DTXAND": "aaaa",
   *   "01J9X5NFS9VKEKGFME97DTXAND-Comment": "vvvv"
   * }
   */
  const isOtherItemSelected = rawValue === 'other' ||
    choices.every((choice) => {
      if (typeof choice === 'object') {
        return choice.value !== rawValue
      }
      return choice !== rawValue
    })
  if (!isOtherItemSelected) {
    return <>{displayValue}</>
  } else {
    return (
      <>
        その他:
        {' '}
        {displayValue}
      </>
    )
  }
}
